import 'babel-polyfill';

require("./scss/app.scss");

import React from 'react';
import ReactDom from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './js/App.jsx';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';

import rootReducer from './js/reducers/index.js';
//import sagaRunner from './js/sagas/sagaRunner.js';

//const sagaMiddleware = createSagaMiddleware();
let store = createStore(
  rootReducer,
  //applyMiddleware(sagaMiddleware),
);

//sagaRunner(sagaMiddleware);

let root = document.getElementById("react-root");

ReactDom.render(
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>,
  root
);
